/**
 * Normalize sales_headers.sales_status values from Zoho/DB:
 * Paid, sent, draft, partially_paid, overdue, void
 */

const STATUS_LABELS = {
  paid: 'Paid',
  sent: 'Sent',
  draft: 'Draft',
  partially_paid: 'Partially Paid',
  overdue: 'Overdue',
  void: 'Void',
};

export function salesStatusKey(raw) {
  if (raw == null || raw === '') return '';
  return String(raw).trim().toLowerCase().replace(/\s+/g, '_');
}

/** Human-readable label for tables and stamps. */
export function formatSalesStatus(raw) {
  const key = salesStatusKey(raw);
  if (!key) return '';
  return STATUS_LABELS[key] || String(raw).trim().replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

/** CSS modifier slug (paid, sent, …). */
export function salesStatusClass(raw) {
  const key = salesStatusKey(raw);
  return STATUS_LABELS[key] ? key : 'unknown';
}
